import { GapDraftAgent, GapDraftAgentStatus } from '@momentum/types';

/**
 * Enrichment agents as the review surface names them.
 *
 * The stored values are lowercase (`enrichment`), but a placeholder saying
 * "owed by ENRICHMENT" is naming a pipeline step, not prose, so it is shown
 * the way the workflow's own logs and prompts write it.
 */
export function agentLabel(agent: GapDraftAgent | string): string {
  return agent.toUpperCase();
}

/** The agent that owes the heading, the overview and the timeline. */
export const OVERVIEW_LABEL = agentLabel(GapDraftAgent.OVERVIEW);

/** The agent that owes the impact, the ROI, the fix steps and the scores. */
export const ENRICHMENT_LABEL = agentLabel(GapDraftAgent.ENRICHMENT);

/** The dot colour beside an agent chip. */
export function agentStatusTone(status: GapDraftAgentStatus): string {
  if (status === GapDraftAgentStatus.DONE) return 'emerald';
  if (status === GapDraftAgentStatus.FAILED) return 'rose';
  return 'cyan';
}
